// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const managedProviderSchema = z.object({
  "id": z.string().uuid(),
  "name": z.string(),
  "kind": z.enum(["platform", "external"])
});

export const managedMandateSchema = z.object({
  "access": z.enum(["disabled", "selected", "full"]),
  "services": z.array(z.string()),
  "permissions": z.array(z.string()),
  "operation_names": z.object({

  }).catchall(z.string()),
  "operations": z.array(z.string()),
  "catalog_revision": z.number().int(),
  "expires_at": z.string().datetime({ offset: true }).nullable(),
  "review_at": z.string().datetime({ offset: true }).nullable()
});

export const managedTenantContextSchema = z.object({
  "prepared": z.boolean(),
  "legacy_platform_delegation": z.boolean(),
  "presentation": z.object({
    "rp_id": z.string(),
    "auth_host": z.string(),
    "scim_endpoint_url": z.string(),
    "tenant_type": z.enum(["workforce", "customer"]),
    "user_source": z.enum(["complete_platform", "existing_idp", "enterprise_fed"])
  }).nullable(),
  "tenant": z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "slug": z.string()
  }),
  "access": z.enum(["disabled", "selected", "full"]),
  "permissions": z.array(z.string()),
  "operations": z.array(z.string()),
  "can_manage_services": z.boolean(),
  "native": z.boolean()
});

export const managedRelationshipSchema = z.object({
  "id": z.string().uuid(),
  "provider_id": z.string().uuid(),
  "revision": z.number().int(),
  "status": z.enum(["draft", "active", "suspended", "revoked"]),
  "updated_at": z.string().datetime({ offset: true }),
  "mandate": managedMandateSchema
});

export const managedAssignmentSchema = z.object({
  "id": z.string().uuid(),
  "relationship_id": z.string().uuid(),
  "team_id": z.string().uuid().nullable(),
  "admin_user_id": z.string().uuid().nullable(),
  "actor_kind": z.enum(["human", "machine"]),
  "permissions": z.array(z.string()),
  "expires_at": z.string().datetime({ offset: true }).nullable(),
  "revoked_at": z.string().datetime({ offset: true }).nullable()
});

export const managedCatalogSchema = z.object({
  "digest": z.string(),
  "operations": z.array(z.object({
    "method": z.string(),
    "pattern": z.string(),
    "name": z.string(),
    "id": z.string(),
    "permissions": z.array(z.string())
  })),
  "revision": z.number().int(),
  "services": z.array(z.object({
    "id": z.string(),
    "name": z.string(),
    "description": z.string(),
    "permissions": z.array(z.string()),
    "additional_tasks": z.array(z.object({
      "id": z.string(),
      "name": z.string(),
      "description": z.string(),
      "permissions": z.array(z.string())
    }))
  }))
});

export const managedWorkspaceSchema = z.object({
  "provider": z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "kind": z.enum(["platform", "external"])
  }).nullable(),
  "can_manage_staff": z.boolean(),
  "teams": z.array(z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "status": z.string(),
    "assignments": z.array(z.object({
      "id": z.string().uuid(),
      "tenant": z.object({
        "id": z.string().uuid(),
        "name": z.string(),
        "slug": z.string()
      }),
      "permissions": z.array(z.string()),
      "expires_at": z.string().datetime({ offset: true }).nullable(),
      "state": z.enum(["active", "suspended", "disabled", "expired", "pending_activation"])
    })),
    "members": z.array(z.string().uuid())
  })),
  "staff": z.array(z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "email": z.string()
  })),
  "customers": z.array(managedTenantContextSchema)
});

export const managedSettingsSchema = z.object({
  "teams": z.array(z.object({
    "provider_id": z.string().uuid(),
    "id": z.string().uuid(),
    "name": z.string(),
    "population": z.enum(["assigned", "platform_admins"])
  })),
  "providers": z.array(managedProviderSchema),
  "relationships": z.array(managedRelationshipSchema),
  "assignments": z.array(managedAssignmentSchema)
});

export const managedMandateChangeSchema = z.object({
  "accepted_catalog_digest": z.string().optional(),
  "expected_revision": z.number().int().min(0),
  "access": z.enum(["disabled", "selected", "full"]),
  "services": z.array(z.string()),
  "expires_at": z.string().datetime({ offset: true }).nullable(),
  "review_at": z.string().datetime({ offset: true }).nullable(),
  "authorization_reference": z.string().min(10).max(1000)
});

export const managedAssignmentChangeSchema = z.object({
  "replaces_id": z.string().uuid().nullable().optional(),
  "relationship_id": z.string().uuid(),
  "expected_revision": z.number().int().min(1),
  "team_id": z.string().uuid().nullable(),
  "admin_user_id": z.string().uuid().nullable(),
  "actor_kind": z.enum(["human", "machine"]),
  "permissions": z.array(z.string()),
  "expires_at": z.string().datetime({ offset: true }).nullable()
});

export const managedRelationshipStatusChangeSchema = z.object({
  "expected_revision": z.number().int().min(1),
  "expected_updated_at": z.string().datetime({ offset: true }),
  "status": z.enum(["active", "suspended", "revoked"])
});

export const managedTeamCreateSchema = z.object({
  "name": z.string().min(1).max(255)
});

export const managedTeamMemberChangeSchema = z.object({
  "active": z.boolean()
});

export const managedIDResponseSchema = z.object({
  "id": z.string().uuid()
});
